import { useLoginContext } from "../../../App";
import { useContentContext } from "../../layout/Layout";
import { getLevelNImagePath } from "../../../services/b2b-frameworks-apiService";
import { showNotification } from "../../b2b-common/Notification";
import { useQuery } from "@tanstack/react-query";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useLevelNImagePath = (frameworkSuite, frameworkId, levelId, locale = null) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-frameworks');

    const fetchImagePath = async (frameworkSuite, frameworkId, levelId, locale) => {
        const { accessToken } = loginData;
        if (!locale) {
            locale = loginData.locale || 'es';
        }
        try {
            const response = await getLevelNImagePath(frameworkSuite, frameworkId, levelId, locale, accessToken);
            const imagePath = await response.text();
            return imagePath;
        } catch (error) {
            console.error('Error fetching levelN image path:', error);
            showNotification(setNotification, t('Error fetching levelN image path: ') + error.message, 'error', 5000);
        }
    };

    const { data: imagePath } = useQuery({
        queryKey: ['imagePath', frameworkSuite, frameworkId, levelId, locale],
        queryFn: () => fetchImagePath(frameworkSuite, frameworkId, levelId, locale),
    });

    return imagePath;
};

export default useLevelNImagePath;